export const ROLE_LIST_DATA = [
  {
    IdProfile: 1000,
    NameProfile: 'Lorem ipsum',
    IsProfileLw: false,
    IdParent: 1000,
    IdCategory: 1,
    IdHead: 1000,
    Description: 'Lorem ipsum',
    CreationDate: '2024-09-24T13:29:24.04Z',
    LastEditionDate: '2025-09-24T13:29:24.04Z',
    Permissions: [
      {
        Name: 'tdb',
        Operations: ['READ']
      },
      {
        Name: 'accessTodaySumMoneyIn',
        Operations: ['READ']
      },
      {
        Name: 'registerWallet',
        Operations: ['WRITE']
      },
      {
        Name: 'editTabOverView',
        Operations: ['READ', 'WRITE']
      }
    ]
  },
  {
    IdProfile: 1001,
    NameProfile: 'Dolor sit amet',
    IsProfileLw: true,
    IdParent: 1000,
    IdCategory: 1,
    IdHead: 1000,
    Description: 'Dolor sit amet',
    CreationDate: '2024-09-24T13:29:24.04Z',
    LastEditionDate: '2025-09-24T13:29:24.04Z',
    Permissions: [
      {
        Name: 'uploadDocument',
        Operations: ['WRITE']
      },
      {
        Name: 'editTabOperation',
        Operations: ['READ']
      },
      {
        Name: 'editTabBankingInformation',
        Operations: ['READ']
      }
    ]
  },
  {
    IdProfile: 1002,
    NameProfile: 'Consectetur adipiscing',
    IsProfileLw: false,
    IdParent: 1000,
    IdCategory: 1,
    IdHead: 1000,
    Description: 'Consectetur adipiscing elit',
    CreationDate: '2024-09-24T13:29:24.04Z',
    LastEditionDate: '2025-09-24T13:29:24.04Z',
    Permissions: [
      {
        Name: 'editTabOverView',
        Operations: ['READ', 'WRITE']
      },
      {
        Name: 'editTabBankingInformationMandatSDD',
        Operations: ['READ']
      },
      {
        Name: 'moneyInSddInit',
        Operations: ['WRITE']
      },
      {
        Name: 'New role without Operations',
        Operations: []
      }
    ]
  },
  {
    IdProfile: 1010,
    NameProfile: 'Consectetur adipiscing',
    IsProfileLw: false,
    IdParent: 1000,
    IdCategory: 1,
    IdHead: 1000,
    Description: 'Consectetur adipiscing elit',
    CreationDate: '2024-09-24T13:29:24.04Z',
    LastEditionDate: '2025-09-24T13:29:24.04Z',
    Permissions: [
      {
        Name: 'editTabOverView',
        Operations: ['READ', 'WRITE']
      },
      {
        Name: 'editTabBankingInformationMandatSDD',
        Operations: ['READ']
      },
      {
        Name: 'moneyInSddInit',
        Operations: ['WRITE']
      },
      {
        Name: 'New role without Operations',
        Operations: []
      }
    ]
  },
  {
    IdProfile: 1011,
    NameProfile: 'Lorem ipsum',
    IsProfileLw: false,
    IdParent: 1000,
    IdCategory: 1,
    IdHead: 1000,
    Description: 'Consectetur lorem adipiscing elit',
    CreationDate: '2024-09-24T13:29:24.04Z',
    LastEditionDate: '2025-09-24T13:29:24.04Z',
    Permissions: [
      {
        Name: 'editTabOverView',
        Operations: ['READ', 'WRITE']
      },
      {
        Name: 'editTabBankingInformationMandatSDD',
        Operations: ['READ']
      },
      {
        Name: 'moneyInSddInit',
        Operations: ['WRITE']
      },
      {
        Name: 'New role without Operations',
        Operations: []
      }
    ]
  }
];
